import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { _localesAllowed } from "../../../../../arc/locale/consts.js";


const maxToday = new Date().toISOString().slice(0, 10);

export const localeOptions = Object.freeze(_localesAllowed.map(value=>({ value })));

export const personalFormFields = Object.freeze([
    { name:"name", required:true, maxLength:64, autoComplete:"name" },
    { name:"birthday", type:"date", max:maxToday },
    { name:"email", type:"email", maxLength:120, autoComplete:"email" },
    { name:"phone", type:"tel", maxLength:24, autoComplete:"tel" },
    { name:"country", maxLength:80, autoComplete:"country-name" },
    { name:"city", maxLength:80, autoComplete:"address-level2" },
    { name:"street", maxLength:120, autoComplete:"address-line1" },
    { name:"house", maxLength:24, autoComplete:"address-line2" },
    { name:"zip", maxLength:16, autoComplete:"postal-code" },
    { name:"locale", required:true, select:true, options:localeOptions, wide:true }
]);

export const personalFormSections = Object.freeze([
    { id:"identity", icon:BadgeOutlinedIcon, fields:["name", "birthday"] },
    { id:"contact", icon:MailOutlineOutlinedIcon, fields:["email", "phone"] },
    { id:"address", icon:GppGoodOutlinedIcon, fields:["country", "city", "street", "house", "zip"] },
    { id:"prefs", icon:SettingsOutlinedIcon, fields:["locale"] }
]);
